import { HyperSpaceBarChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpaceBarChart';
import { HyperSpaceColumnChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpaceColumnChart';
import { HyperSpaceLineChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpaceLineChart';
import { HyperSpacePieChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpacePieChart';
import { HyperSpaceAreaChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpaceAreaChart';
import { HyperSpaceDualAxisChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpaceDualAxisChart';
import { HyperSpaceComboChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpaceComboChart';
import { HyperSpaceStackedBarChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpaceStackedBarChart';
import { HyperSpaceStackedColumnChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpaceStackedColumnChart';
import { HyperSpaceBubblePlotChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpaceBubblePlotChart';
import { HyperSpaceAxisBubbleChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpaceAxisBubbleChart';
import { HyperSpaceTreeMap } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/widgets/HyperSpaceTreeMap';

import { TemplateHyperSpaceBarChart } from './templates/TemplateHyperSpaceBarChart';
import { TemplateHyperSpaceColumnChart } from './templates/TemplateHyperSpaceColumnChart';
import { TemplateHyperSpaceLineChart } from './templates/TemplateHyperSpaceLineChart';
import { TemplateHyperSpacePieChart } from './templates/TemplateHyperSpacePieChartWidget';
import { TemplateHyperSpaceStackedBarChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/templates/TemplateHyperSpaceStackedBarChart';
import { TemplateHyperSpaceStackedColumnChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/templates/TemplateHyperSpaceStackedColumnChart';
import { TemplateHyperSpaceBubblePlotChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/templates/TemplateHyperSpaceBubblePlotChart';
import { TemplateHyperSpaceAreaChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/templates/TemplateHyperSpaceAreaChart';
import { TemplateHyperSpaceDualAxisChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/templates/TemplateHyperSpaceDualAxisChart';
import { TemplateHyperSpaceComboChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/templates/TemplateHyperSpaceComboChart';
import { TemplateHyperSpaceAxisBubbleChart } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/templates/TemplateHyperSpaceAxisBubbleChart';
import { TemplateHyperSpaceTreeMap } from '@sprinklr/display-builder/stores/PanelTemplatesStore/HyperSpace/templates/TemplateHyperSpaceTreeMap';

export const hyperSpaceWidgets = {
    panels: {},
    widgets: {
        analytics: [
            HyperSpaceBarChart,
            HyperSpaceColumnChart,
            HyperSpaceLineChart,
            HyperSpacePieChart,
            HyperSpaceAreaChart,
            HyperSpaceDualAxisChart,
            HyperSpaceComboChart,
            HyperSpaceStackedBarChart,
            HyperSpaceStackedColumnChart,
            HyperSpaceBubblePlotChart,
            HyperSpaceAxisBubbleChart,
            HyperSpaceTreeMap,
        ],
    },
};

export const hyperSpaceTemplates = {
    panels: {},
    templates: {
        analytics: [
            TemplateHyperSpaceBarChart,
            TemplateHyperSpaceColumnChart,
            TemplateHyperSpaceLineChart,
            TemplateHyperSpacePieChart,
            TemplateHyperSpaceAreaChart,
            TemplateHyperSpaceDualAxisChart,
            TemplateHyperSpaceComboChart,
            TemplateHyperSpaceStackedBarChart,
            TemplateHyperSpaceStackedColumnChart,
            TemplateHyperSpaceBubblePlotChart,
            TemplateHyperSpaceAxisBubbleChart,
            TemplateHyperSpaceTreeMap,
        ],
    },
};
